require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon")) : factory(root["./utils"], root["./svgicon"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__10__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[15],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-container.react-resizable svg.resize-handler-icon:focus{outline:2px solid #a8c0f3}.ba-common-container.react-resizable{position:relative}.ba-common-container.react-resizable svg.resize-handler-icon{position:absolute;margin:auto;display:block;z-index:2}.ba-common-container.react-resizable .react-resizable-handle{background-color:#eaeaea;box-sizing:border-box;position:absolute;margin:auto}@media screen and (-ms-high-contrast: active){.ba-common-container.react-resizable .react-resizable-handle{border:1px solid #fff}}.ba-common-container.react-resizable.is-x{padding-right:8px;height:100% !important}.ba-common-container.react-resizable.is-x svg.resize-handler-icon-e{width:8px;top:0;bottom:0;right:0}.ba-common-container.react-resizable.is-x svg.resize-handler-icon-w{width:8px;top:0;bottom:0;left:0}.ba-common-container.react-resizable.is-x .react-resizable-handle-e{width:8px;height:100%;top:0;bottom:0;right:0;cursor:col-resize}.ba-common-container.react-resizable.is-x .react-resizable-handle-w{width:8px;height:100%;top:0;bottom:0;left:0;cursor:col-resize}.ba-common-container.react-resizable.is-y{padding-bottom:8px;width:100% !important}.ba-common-container.react-resizable.is-y svg.resize-handler-icon-s{height:16px;left:50%;bottom:-4px;transform:rotate(90deg)}.ba-common-container.react-resizable.is-y svg.resize-handler-icon-n{height:16px;left:50%;top:-4px;transform:rotate(90deg)}.ba-common-container.react-resizable.is-y .react-resizable-handle-n{height:8px;width:100%;top:0;right:0;left:0;cursor:row-resize}.ba-common-container.react-resizable.is-y .react-resizable-handle-s{height:8px;width:100%;bottom:0;right:0;left:0;cursor:row-resize}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-se{width:16px;height:16px;right:0;bottom:0}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-sw{width:16px;height:16px;bottom:0px;left:0px}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-nw{width:16px;height:16px;top:0px;left:0px}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-ne{width:16px;height:16px;top:0px;right:0px}.ba-common-container.react-resizable.is-both .react-resizable-handle-se{width:16px;height:16px;bottom:0;right:0;cursor:se-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-sw{width:16px;height:16px;bottom:0px;left:0px;cursor:sw-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-ne{width:16px;height:16px;top:0px;right:0px;cursor:ne-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-nw{width:16px;height:16px;top:0px;left:0px;cursor:nw-resize}", ""]);

// exports
exports.locals = {
	"containerClassName": "\"ba-common-container\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(269);


/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Container = _interopRequireDefault(__webpack_require__(270));

exports.default = _Container.default;
exports.Container = _Container.default;

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _reactResizable = __webpack_require__(271);

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _resizePanel_ = _interopRequireDefault(__webpack_require__(272));

var _Container = _interopRequireDefault(__webpack_require__(273));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  sizeArrayToCss,
  mergeStyles
} = _utils.cssUtils;
const {
  sanitize
} = _utils.propsUtils;
const {
  isKey,
  keyNames
} = _utils.keyboardUtils;

const containerClassName = _Container.default.containerClassName.replace(/"/g, '');

const KB_RESIZE_STEP = 5;

class Container extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_onResize", (event, data) => {
      this.setState({
        width: data.size.width,
        height: data.size.height
      });
      this.props.onResize(event, data);
    });
    (0, _defineProperty2.default)(this, "_handler", h => /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      "aria-label": "resizable-container__handler",
      "data-tid": "ba-common-resizable-container__handler",
      className: `resize-handler-icon resize-handler-icon-${h}`,
      tabIndex: "0",
      onKeyDown: this._onResizeHandlerKeyDown,
      iconId: _resizePanel_.default.id
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: `react-resizable-handle react-resizable-handle-${h}`
    })));
    (0, _defineProperty2.default)(this, "_onResizeHandlerKeyDown", e => {
      const {
        LEFT,
        RIGHT,
        UP,
        DOWN
      } = keyNames;
      const {
        resizeDirection,
        resizeMinConstraintsX,
        resizeMaxConstraintsX,
        resizeMinConstraintsY,
        resizeMaxConstraintsY
      } = this.props;
      const {
        width,
        height
      } = this.state;

      if (isKey(e, LEFT) || isKey(e, RIGHT) || isKey(e, UP) || isKey(e, DOWN)) {
        if (resizeDirection === 'x') {
          if (isKey(e, LEFT) && resizeMinConstraintsX <= width - KB_RESIZE_STEP) {
            this.setState({
              width: width - KB_RESIZE_STEP
            });
          } else if (isKey(e, RIGHT) && resizeMaxConstraintsX >= width + KB_RESIZE_STEP) {
            this.setState({
              width: width + KB_RESIZE_STEP
            });
          }
        } else if (resizeDirection === 'y') {
          if (isKey(e, UP) && resizeMinConstraintsY <= height - KB_RESIZE_STEP) {
            this.setState({
              height: height - KB_RESIZE_STEP
            });
          } else if (isKey(e, DOWN) && resizeMaxConstraintsY >= height + KB_RESIZE_STEP) {
            this.setState({
              height: height + KB_RESIZE_STEP
            });
          }
        }

        e.preventDefault();
      }
    });
    (0, _defineProperty2.default)(this, "_ref", node => {
      this._node = node;
    });
    this.state = {
      width: 0,
      height: 0
    };
  }

  componentDidMount() {
    const {
      resizable
    } = this.props;

    if (resizable) {
      this.setState({
        height: this._node.offsetHeight,
        width: this._node.offsetWidth
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      resizable
    } = this.props;

    if (resizable && (prevState.height !== this._node.offsetHeight || prevState.width !== this._node.offsetWidth)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        height: this._node.offsetHeight,
        width: this._node.offsetWidth
      });
    }
  }

  render() {
    const {
      children,
      gutter,
      margin,
      padding,
      width,
      height,
      minWidth,
      minHeight,
      maxWidth,
      maxHeight,
      overflow,
      relative,
      textAlign,
      style,
      resizable,
      resizeDirection,
      resizeMinConstraintsX,
      resizeMinConstraintsY,
      resizeMaxConstraintsX,
      resizeMaxConstraintsY,
      className,
      onResizeStart,
      onResizeStop,
      id,
      isPassive,
      resizeHandles,
      ...others
    } = this.props;
    const styles = mergeStyles(style, {
      overflow,
      width,
      height,
      minWidth,
      minHeight,
      maxWidth,
      maxHeight,
      textAlign,
      margin: sizeArrayToCss(margin),
      padding: sizeArrayToCss(gutter || padding)
    });

    if (relative) {
      styles.position = 'relative';
    }

    const adjustedWidth = this.state.width === 0 ? this.props.width : this.props.isPassive ? this.props.width : this.state.width;
    const adjustedHeight = this.state.height === 0 ? this.props.height : this.props.isPassive ? this.props.height : this.state.height;
    const classNames = (0, _utils.classnames)(containerClassName);
    const containerComponentClass = `${classNames} ${className}`;
    let defaultResizeHandles;

    if (resizable) {
      if (resizeHandles === undefined) {
        switch (resizeDirection) {
          case 'x':
            defaultResizeHandles = ['e'];
            break;

          case 'y':
            defaultResizeHandles = ['s'];
            break;

          case 'both':
            defaultResizeHandles = ['se'];
            break;

          default:
        }
      }

      return /*#__PURE__*/_react.default.createElement(_reactResizable.Resizable, (0, _extends2.default)({}, sanitize(others, Container), {
        axis: resizeDirection // BAUICOMMON-803 Expression editor window fix
        // if the browser is being resized then pass props.width and props.height to respect browser size
        ,
        height: isPassive ? height : this.state.height,
        width: isPassive ? width : this.state.width,
        onResize: this._onResize,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        minConstraints: [resizeMinConstraintsX, resizeMinConstraintsY],
        maxConstraints: [resizeMaxConstraintsX, resizeMaxConstraintsY],
        resizeHandles: resizeHandles === undefined ? defaultResizeHandles : resizeHandles,
        handle: this._handler
      }), /*#__PURE__*/_react.default.createElement("div", {
        id: id,
        className: (0, _utils.classnames)(containerComponentClass, resizeDirection),
        style: { ...styles,
          // BAUICOMMON-803 Expression editor window fix
          // if the browser is being resized then pass props.width and props.height to respect browser size
          width: adjustedWidth,
          height: adjustedHeight
        },
        ref: this._ref
      }, children));
    }

    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      id: id,
      className: containerComponentClass,
      ref: this._ref
    }, sanitize(others, Container), {
      style: styles
    }), children);
  }

}

exports.default = Container;
(0, _defineProperty2.default)(Container, "propTypes", {
  gutter: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  margin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  padding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  minWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  minHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  overflow: _propTypes.default.string,
  relative: _propTypes.default.bool,
  children: _propTypes.default.node,
  textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),
  style: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  resizable: _propTypes.default.bool,
  resizeDirection: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),
  resizeMinConstraintsX: _propTypes.default.number,
  resizeMinConstraintsY: _propTypes.default.number,
  resizeMaxConstraintsX: _propTypes.default.number,
  resizeMaxConstraintsY: _propTypes.default.number,
  onResize: _propTypes.default.func,
  onResizeStart: _propTypes.default.func,
  onResizeStop: _propTypes.default.func,
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  resizeHandles: _propTypes.default.array,
  isPassive: _propTypes.default.bool // to allow caller control the size by width and height props

});
(0, _defineProperty2.default)(Container, "defaultProps", {
  resizable: false,
  resizeDirection: 'x',
  className: '',
  style: {},
  resizeMinConstraintsX: 32,
  resizeMinConstraintsY: 32,
  resizeMaxConstraintsX: Number.POSITIVE_INFINITY,
  resizeMaxConstraintsY: Number.POSITIVE_INFINITY,
  onResize: () => {},
  onResizeStart: () => {},
  onResizeStop: () => {}
});

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports = require("react-resizable");

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/resize-panel_24");

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Container_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(100);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Container_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Container_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Container_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_Container_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[268,0]]]);
});